import gameConsts from './gameConsts';

export default class GameObject {
  constructor({ game, values, name }) {
    this._game = game;
    this._name = name;
    this._playerData = values;
    this._img = this._game.cache.getFrameData('nfs').getFrameByName(`${this._name}.png`);
    this._defaultWidth = this._img.width;
    this.defaultHeight = this._img.height;
  }
  // eslint-disable-next-line
  get _scaleValue() {
    return window.innerWidth <= gameConsts.WINDOW_SCALING_WIDTH ? gameConsts.SCALE_VALUE_XS : gameConsts.SCALE_VALUE;
  }
  get width() {
    return this._scaleValue * this._defaultWidth;
  }
  get height() {
    return this._scaleValue * this.defaultHeight;
  }
  scaleItem() {
    this.item.scale.setTo(this._scaleValue, this._scaleValue);
  }
}



// WEBPACK FOOTER //
// ./src/js/GameObject.js